export const translations = {
  'zh-CN': {
    // TopNav
    'nav.models': '模型库',
    'nav.contact': '联系',
    'nav.console': '进入控制台',

    // Hero
    'hero.eyebrow': '统一 AI 模型中转网关',
    'hero.title.line1': '一个端点。',
    'hero.title.line2': '所有主流模型。',
    'hero.lead': 'Claude API · Claude Code · Codex · GPT Image — 统一 OpenAI 兼容协议，多区域智能路由，零迁移成本接入。',
    'hero.lead.mute': '把你已有的 SDK 指过来，立即可用。',
    'hero.cta.console': '进入控制台',
    'hero.cta.models': '浏览模型库',
    'hero.term.label': '实时请求日志',

    // Models
    'models.kicker': 'MODEL LIBRARY',
    'models.title': '模型库 / model registry',
    'models.subtitle': '接入 {vendors} 家厂商 · {total} 个模型 · 全部 OpenAI 兼容接口可调用',
    'models.filter': 'filter --group',
    'models.matched': '// matched: ',
    'models.vendor': 'vendor :: ',
    'models.count': ' models',

    // Contact
    'contact.kicker': 'CONTACT',
    'contact.title': '联系 / get in touch',
    'contact.subtitle': '开通账号 · 商务合作 · 技术支持，全部走邮件',
    'contact.desc2': '支持 7×24 响应，工作时段（UTC+8 09:00–24:00）通常 30 分钟内回复。',
    'contact.cta.email': '发送邮件',
    'contact.cta.copy': '复制邮箱',
    'contact.meta.backup': '在控制台内提工单同样可达',

    // Footer
    'footer.console': '控制台',
    'footer.models': '模型库',
    'footer.about': '关于我们',
    'footer.privacy': '隐私政策',
    'footer.terms': '服务条款',
    'footer.built': 'built for developers',
  },

  'en': {
    // TopNav
    'nav.models': 'Models',
    'nav.contact': 'Contact',
    'nav.console': 'Console',

    // Hero
    'hero.eyebrow': 'Unified AI Model Gateway',
    'hero.title.line1': 'One endpoint.',
    'hero.title.line2': 'All major models.',
    'hero.lead': 'Claude API · Claude Code · Codex · GPT Image — unified OpenAI-compatible protocol, multi-region intelligent routing, zero migration cost.',
    'hero.lead.mute': 'Point your existing SDK here, ready to use immediately.',
    'hero.cta.console': 'Go to Console',
    'hero.cta.models': 'Browse Models',
    'hero.term.label': 'Real-time request logs',

    // Models
    'models.kicker': 'MODEL LIBRARY',
    'models.title': 'Model Library',
    'models.subtitle': '{vendors} vendors · {total} models · All OpenAI-compatible',
    'models.filter': 'filter --group',
    'models.matched': '// matched: ',
    'models.vendor': 'vendor :: ',
    'models.count': ' models',

    // Contact
    'contact.kicker': 'CONTACT',
    'contact.title': 'Get in Touch',
    'contact.subtitle': 'Account setup · Business · Support, all via email',
    'contact.desc2': '7×24 support, typically respond within 30 minutes during business hours (UTC+8 09:00–24:00).',
    'contact.cta.email': 'Send Email',
    'contact.cta.copy': 'Copy Address',
    'contact.meta.backup': 'You can also submit tickets in the console',

    // Footer
    'footer.console': 'Console',
    'footer.models': 'Models',
    'footer.about': 'About',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.built': 'built for developers',
  },

  'zh-TW': {
    // TopNav
    'nav.models': '模型庫',
    'nav.contact': '聯絡',
    'nav.console': '進入控制台',

    // Hero
    'hero.eyebrow': '統一 AI 模型中轉閘道',
    'hero.title.line1': '一個端點。',
    'hero.title.line2': '所有主流模型。',
    'hero.lead': 'Claude API · Claude Code · Codex · GPT Image — 統一 OpenAI 相容協定，多區域智慧路由，零遷移成本接入。',
    'hero.lead.mute': '把你現有的 SDK 指過來，立即可用。',
    'hero.cta.console': '進入控制台',
    'hero.cta.models': '瀏覽模型庫',
    'hero.term.label': '即時請求日誌',

    // Models
    'models.kicker': 'MODEL LIBRARY',
    'models.title': '模型庫 / model registry',
    'models.subtitle': '接入 {vendors} 家廠商 · {total} 個模型 · 全部 OpenAI 相容介面可呼叫',
    'models.filter': 'filter --group',
    'models.matched': '// matched: ',
    'models.vendor': 'vendor :: ',
    'models.count': ' models',

    // Contact
    'contact.kicker': 'CONTACT',
    'contact.title': '聯絡 / get in touch',
    'contact.subtitle': '開通帳號 · 商務合作 · 技術支援，全部走郵件',
    'contact.desc2': '支援 7×24 回應，工作時段（UTC+8 09:00–24:00）通常 30 分鐘內回覆。',
    'contact.cta.email': '寄送郵件',
    'contact.cta.copy': '複製信箱',
    'contact.meta.backup': '在控制台內提工單同樣可達',

    // Footer
    'footer.console': '控制台',
    'footer.models': '模型庫',
    'footer.about': '關於我們',
    'footer.privacy': '隱私政策',
    'footer.terms': '服務條款',
    'footer.built': 'built for developers',
  },

  'ja': {
    // TopNav
    'nav.models': 'モデル一覧',
    'nav.contact': 'お問い合わせ',
    'nav.console': 'コンソールへ',

    // Hero
    'hero.eyebrow': '統合 AI モデルゲートウェイ',
    'hero.title.line1': 'ひとつの接続先。',
    'hero.title.line2': '主要モデルすべて。',
    'hero.lead': 'Claude API · Claude Code · Codex · GPT Image — OpenAI 互換プロトコルに統一。マルチリージョンのインテリジェントルーティングで、移行コストはゼロ。',
    'hero.lead.mute': '既存の SDK の向き先を変えるだけで、すぐに使えます。',
    'hero.cta.console': 'コンソールへ',
    'hero.cta.models': 'モデルを見る',
    'hero.term.label': 'リアルタイムリクエストログ',

    // Models
    'models.kicker': 'MODEL LIBRARY',
    'models.title': 'モデル一覧 / model registry',
    'models.subtitle': '{vendors} 社 · {total} モデル · すべて OpenAI 互換インターフェースで呼び出し可能',
    'models.filter': 'filter --group',
    'models.matched': '// matched: ',
    'models.vendor': 'vendor :: ',
    'models.count': ' models',

    // Contact
    'contact.kicker': 'CONTACT',
    'contact.title': 'お問い合わせ / get in touch',
    'contact.subtitle': 'アカウント開設 · 法人のご相談 · 技術サポート、すべてメールで承ります',
    'contact.desc2': '24 時間 365 日対応。営業時間内（UTC+8 09:00–24:00）は通常 30 分以内に返信します。',
    'contact.cta.email': 'メールを送る',
    'contact.cta.copy': 'アドレスをコピー',
    'contact.meta.backup': 'コンソールからチケットでもご連絡いただけます',

    // Footer
    'footer.console': 'コンソール',
    'footer.models': 'モデル一覧',
    'footer.about': '運営会社',
    'footer.privacy': 'プライバシーポリシー',
    'footer.terms': '利用規約',
    'footer.built': 'built for developers',
  }
};
